import { AdOverviewAd } from '../../../../app/api'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'

export const PositionCell = (props: AdOverviewAd) => {
  const { t } = useTranslation()

  return (
    <div className={'item-center flex items-center gap-[8px]'}>
      {props.position_global}
      {props.is_top && (
        <Tooltip title={t('pages.adOverview.topPositionTooltip')}>
          <div
            className={
              'cursor-default rounded-[4px] bg-danger/[.07] px-[6px] py-[2px] text-[10px] font-semibold uppercase leading-[16px] text-danger/[.75]'
            }
          >
            {t('pages.adOverview.top')}
          </div>
        </Tooltip>
      )}
    </div>
  )
}
